import React from 'react'

import CmsImage from '~/components/cms-image'
import Link from '~/components/link'
import ShareButton from '~/components/share/button'
import { IPost } from '~/types/posts'
import { getPageSlug, getPageUrl } from '~/utils/page'

interface Props {
  post: IPost
}

const PostCard: React.FC<Props> = ({ post }) => {
  const postUrl = getPageSlug(post.slug, 'post')
  const shareUrl = getPageUrl(post.slug, 'post')
  const category = post.onPostCategory?.data?.attributes?.name

  return (
    <article className="relative w-full h-full">
      <Link href={postUrl} className="group flex flex-col w-full h-full">
        <div className="mb-6 relative w-full h-[13.75rem] overflow-hidden">
          <CmsImage
            attributes={post.thumbnail?.data?.attributes}
            className="w-full h-full object-cover object-center transition-transform group-hover:scale-105"
            width={420}
          />
        </div>
        <p className="text-xs font-bold uppercase tracking-wide max-w-[90%]">
          {category}
        </p>
        <h3 className="mt-2 text-lg transition-colors group-hover:text-hover-color font-sans font-normal leading-snug normal-case">
          {post.title}
        </h3>
      </Link>
      <div className="absolute top-[15rem] right-0">
        <ShareButton title={post.title} shareUrl={shareUrl} />
      </div>
    </article>
  )
}

export default PostCard
